
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skisted",
      function () {
        return require("private-next-pages/[region]/[resort]/skisted.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skisted"])
      });
    }
  